import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { loadMessages } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import { HolidaySystem, HolidaySystemDetail, HolidaySystemSubDetail } from 'src/app/Interfaces/hr/holiday-system';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { DetailGridComponent } from './detail-grid/detail-grid.component'
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';

@Component({
  selector: 'app-add-edit-holiday-header-system',
  templateUrl: './add-edit-holiday-header-system.component.html',
  styleUrls: ['./add-edit-holiday-header-system.component.scss']
})
export class AddEditHolidayHeaderSystemComponent implements OnInit {
  holidaySystem: HolidaySystem[] = []
  holidayheaderid: number;
  holidayData: any = []
  holidaydropdown: any = {}
  personalsettingform: any = []
  holidayList: HolidaySystemSubDetail[] = []
  button = {}
  holidaySystemDetails: HolidaySystemDetail[] = []
  totalHoliday: number = 0;
  totaluserHoliday: number = 0;
  userHoliday: number = 0;
  buttonOptions = {
    text: this.translate.instant('HolidayWorkSystem.add'),
    type: 'default',
    useSubmitBehavior: true,
    disabled:this.holidayList.length <= 0
  };

   // loading
   loading:boolean=false

  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;
  @ViewChild(DetailGridComponent) holidayDetails: DetailGridComponent
  constructor(private validation: CheckValidation, public _publicSettingService: publicSettingService,
    public gt: genericCustomStoreService, public Objects: ObjectsService, public translate: TranslateService, public router: Router) {
    this._publicSettingService.$Holiday_Edit_Start.next(false)
    gt.getdropdowndata("HolidayType").subscribe(res => this.holidaydropdown = res)
    this.validateAsync = this.validateAsync.bind(this);
    this.setCellValueHoliday = this.setCellValueHoliday.bind(this)
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });
    this._publicSettingService.$Holiday_ID.subscribe(res => this.holidayheaderid = res)
    if (this.holidayheaderid != 0) {
      this.loading=true;
      this._publicSettingService.byKey("HolidayHeaderSystem", this.holidayheaderid).subscribe((res: any) => {
        this.personalsettingform.nameAr = res.nameAr;
        this.holidayData.holidaySystemDetails = res.holidaySystemDetails
        this.holidaySystemDetails = res.holidaySystemDetails

        this.loading=false;
      })
    }

  }

  ngOnInit(): void {
    this._publicSettingService.$Holiday_Edit_Start.subscribe(res => {
      if (res) {
        this.personalsettingform.fromAge = this.holidayDetails.editdata.fromAge
        this.personalsettingform.toAge = this.holidayDetails.editdata.toAge
        this.personalsettingform.countDay = this.holidayDetails.editdata.countDay
        this.holidayList = this.holidayDetails.editdata.holidaySystemSubDetails
      }
    })
  }

  validateAsync(params: any) {
    var id = this.holidayheaderid;
    return this.validation.asyncCheckNameValue(params.value, id, "HolidayHeaderSystem");
  }


  onFormSubmit(e: Event) {
    e.preventDefault()
    this.holidaySystemDetails.push({
      id: 0,
      fromAge: this.personalsettingform.fromAge,
      toAge: this.personalsettingform.toAge,
      holidayHeaderSystemId: this.holidayheaderid,
      countDay: this.personalsettingform.countDay,
      holidaySystemSubDetails: this.holidayList
    })
    this.holidayData =
    {
      id: this.holidayheaderid,
      nameAr: this.personalsettingform.nameAr,
      holidaySystemDetails: this.holidaySystemDetails
    }
    this.holidayList = []
    this.totaluserHoliday = 0;
  }

  SubmitData(e: Event) {
    if (this.holidayheaderid != 0) {
      this._publicSettingService.update("HolidayHeaderSystem", this.holidayData).subscribe(res => {
        this._publicSettingService.$Holiday_ReFRESH.next(true)
        this.router.navigate(['hr/HolidayHeaderWorkSystem'])
      })
    }
    else {
      this._publicSettingService.add("HolidayHeaderSystem", this.holidayData).subscribe(res => {
        this._publicSettingService.$Holiday_ReFRESH.next(true)
        this.router.navigate(['hr/HolidayHeaderWorkSystem'])
      })
    }
  }


  onInsertedHoliday(e: any) {
    this.totalHoliday = this.personalsettingform.countDay??0;
    this.totaluserHoliday += Number(this.userHoliday)
    if (this.totaluserHoliday > this.totalHoliday) {
      e.cancel = true
      this.totaluserHoliday -= Number(this.userHoliday)
      notify({
        message: `${this.translate.instant('errors.holiday')}`,
        height: 45,
        width: 900,
        minWidth: 150,
        type: 'error',
        displayTime: 1700,
        animation: {
          show: {
            type: 'fade', duration: 100, from: 0, to: 1,
          },
          hide: { type: 'fade', duration: 40, to: 0 },
        },
      });

    }
    else {
      e.cancel = false
      notify({
        message: `add successfully`,
        height: 45,
        width: 900,
        minWidth: 150,
        type: 'success',
        displayTime: 1700,
        animation: {
          show: {
            type: 'fade', duration: 100, from: 0, to: 1,
          },
          hide: { type: 'fade', duration: 40, to: 0 },
        },
      });
    }
  }

  onRemovedHoliday(e: Event) {
    this.totaluserHoliday -= Number(this.userHoliday)
  }

  onInitNewRowHoiday(e: any) {
    debugger
    e.data.id = 0;
    e.data.holidaySystemDetailsId = 0
  }
  setCellValueHoliday(newData: any, value: any) {
    newData.holidayTypeId = value;
    let day = this.holidaydropdown.filter((ele: any) => {
      return ele.id == value ? ele.countDay : ''
    })
    newData.holidayNumber = day[0].countDay;
    this.userHoliday = day[0].countDay
  }
  
  // backToMainPage(e:string){
  //   if(e=='back'){
  //     this.router.navigate(['/hr/HolidayHeaderWorkSystem'])
  //   }
  // }

  addrowfun(name: string) {
    return this.gt.addrow(name)
  }

}
